<app-table
  #table
  rowIdKey="id"
  [title]="title"
  [columns]="columns"
  [data]="filteredData"
  [rowActions]="rowActions"
  [globalActions]="globalActions"
  (event)="onEvent($event)"
  [nbSpinner]="loading"
></app-table>
